import { useState } from "react";
import { useNavigate } from "react-router-dom";

const KEY_ID   = "key_2xNpQ8mRtL4vKw";
const MOCK_KEY = "sk_live_krestpay_x9f2mK8pQrT4vNwL3hJdYeUbCiAoZs7G";

const LOGS = [
  { action: "Key Revoked",  time: "Apr 10, 2025 · 14:32", ip: "103.21.58.12",  outcome: "Key Expired",   dot: "bg-red-500",    outColor: "text-red-600" },
  { action: "Auth Failure", time: "Apr 10, 2025 · 14:30", ip: "103.21.58.12",  outcome: "Access Denied", dot: "bg-orange-400", outColor: "text-orange-500" },
  { action: "API Request",  time: "Apr 10, 2025 · 12:15", ip: "182.74.33.201", outcome: "Success",       dot: "bg-gray-400",   outColor: "text-emerald-600" },
];

export default function RevokedApiKeyPage() {
  const navigate   = useNavigate();
  const maskedKey  = MOCK_KEY.slice(0, 14) + "••••••••••••••••••••" + MOCK_KEY.slice(-6);

  return (
        <div className="flex-1 overflow-y-auto px-12 py-7">

          {/* Page Header */}
          <div className="mb-6">
            <h1 className="text-[40px] font-bold text-[#34094D]">My API Key</h1>
            <p className="text-[14px] font-medium text-[#34094D99] mt-1">Account Settings › Developer Tools</p>
          </div>

          {/* Red Alert Banner */}
          <div className="flex items-start gap-4 bg-[#FFDAD666] border-l-4 border-[#BA1A1A] shadow-[0px_10px_20px_0px_#BA1A1A0A] rounded-[12px] px-5 py-3 mb-7">
            <div className="w-8 h-8 rounded-full bg-[#BA1A1A] flex items-center justify-center shrink-0 mt-0.5">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <p className="text-[18px] font-bold text-[#93000A]">API key revoked.</p>
              <p className="text-[14px] text-[#93000A] leading-relaxed">
                This key is no longer active and cannot be used for any API requests. Please generate a new key to resume services.
              </p>
            </div>
          </div>

          {/* Two Column 65/35 */}
          <div className="grid gap-8 mb-6" style={{ gridTemplateColumns: "1fr 0.55fr" }}>

            {/* LEFT — Revoked Key Card */}
            <div className="bg-white rounded-[32px] shadow-[0px_24px_32px_0px_#4B23640D] p-7 flex flex-col gap-6">

              {/* API Key ID + INACTIVE badge */}
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-[10px] font-bold text-[#4C444E99] uppercase tracking-widest mb-1.5">API Key ID</p>
                  <p className="text-[20px] font-semibold text-[#4C444E] font-regular">{KEY_ID}</p>
                </div>
                <span className="inline-flex items-center gap-1.5 text-[11px] font-bold text-[#DC2626] bg-[#FEE2E2] px-3 py-1 rounded-full shrink-0">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#DC2626] inline-block"/>
                  INACTIVE
                </span>
              </div>

              {/* Secret Key — blurred + disabled */}
              <div className="bg-[#F3F4F5] rounded-[16px] border border-[#CEC3D01A] p-6 flex flex-col">
                <p className="text-[10px] font-bold text-[#4C444E99] uppercase tracking-widest">Secret Key</p>
                <div className="flex items-center overflow-hidden">
                  <div className="w-1 self-stretch shrink-0" />
                  <code className="flex-1 text-[16px] font-mono text-[#4C444E] py-2 truncate select-none line-through decoration-[#4C444E66] decoration-2">
                    {MOCK_KEY}
                  </code>
                  <div className="pr-3">
                    <div className="w-8 h-8 flex items-center justify-center text-[#4C444E4D]">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-[#F3F4F6]" />

              {/* Info */}
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <p className="text-[11px] font-bold text-[#4C444E99] mb-1.5">Revoked At</p>
                  <p className="text-[16px] font-bold text-[#111827]">Apr 10, 2025, 14:32</p>
                </div>
                <div>
                  <p className="text-[11px] font-bold text-[#4C444E99] mb-1.5">Rate Limit</p>
                  <p className="text-[16px] font-bold text-[#111827]">100,000 / month</p>
                </div>
              </div>

            </div>

            {/* RIGHT */}
            <div className="flex flex-col gap-5">

              {/* CTA Card */}
              <div className="rounded-[32px] bg-[linear-gradient(131deg,#754F89_0%,#4B2364_100%)] shadow-[0px_8px_10px_-6px_#0000001A,0px_20px_25px_-5px_#0000001A] p-8 flex flex-col gap-5">
                <div>
                  <p className="text-[24px] font-semibold text-white leading-tight">Need access?</p>
                  <p className="text-[14px] text-[#F3E8FFB2] mt-2 leading-relaxed">
                    Your current credentials have been expired. Generate a new set to re-authenticate your merchant integration.
                  </p>
                </div>
                <button
                  onClick={() => navigate("/api-key")}
                  className="flex items-center justify-center gap-2 text-[14px] font-bold text-white py-3 rounded-[12px] border-none cursor-pointer bg-[linear-gradient(104.66deg,#EA8534_0%,#A0111A_100%)] hover:opacity-90 transition-all"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M21 12a9 9 0 11-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                  Generate New Key
                </button>
              </div>

              {/* Documentation Card */}
              <div className="bg-[#F3F4F5] rounded-[32px] border border-[#CEC3D01A] p-5 flex flex-col gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-[12px] bg-[#34094D1A] flex items-center justify-center shrink-0">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#34094D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                      <line x1="16" y1="13" x2="8" y2="13"/>
                      <line x1="16" y1="17" x2="8" y2="17"/>
                    </svg>
                  </div>
                  <p className="text-[18px] font-bold text-[#191C1D]">Documentation</p>
                </div>
                <p className="text-[14px] font-regular text-[#4C444E] leading-relaxed">
                  Learn how to integrate your new API key safely in our developer guide.
                </p>
                <button className="text-[14px] font-bold text-[#34094D] bg-transparent border-none cursor-pointer text-left p-0 hover:underline">
                  View API Docs →
                </button>
              </div>
            </div>
          </div>

          {/* Activity Log */}
          <div className="bg-white rounded-[20px] shadow-[0px_8px_24px_rgba(0,0,0,0.05)] overflow-hidden">
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#F3F4F6]">
              <div>
                <p className="text-[24px] font-bold text-[#191C1D]">Key Activity Log</p>
                <p className="text-[14px] font-regular text-[#4C444E] mt-0.5">Historical operations performed with this key</p>
              </div>
              <button className="flex items-center gap-2 text-[14px] font-bold text-[#34094D] px-4 py-2 rounded-[10px] border-none cursor-pointer transition-colors">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 4h18M7 12h10M10 20h4"/></svg>
                Filter Logs
              </button>
            </div>
            <div className="grid grid-cols-4 px-6 py-3 bg-[#F9FAFB] border-b border-[#F3F4F6]">
              {["Action", "Date & Time", "IP Address", "Outcome"].map(h => (
                <p key={h} className="text-[11px] font-bold text-[#9CA3AF] uppercase tracking-wider">{h}</p>
              ))}
            </div>
            {LOGS.map((log, i) => (
              <div key={i} className={`grid grid-cols-4 px-6 py-4 items-center hover:bg-[#FAFAFA] transition-colors ${i < LOGS.length - 1 ? "border-b border-[#F3F4F6]" : ""}`}>
                <div className="flex items-center gap-2.5">
                  <span className={`w-2 h-2 rounded-full shrink-0 ${log.dot}`} />
                  <span className="text-[13px] font-medium text-[#111827]">{log.action}</span>
                </div>
                <span className="text-[12px] text-[#6B7280]">{log.time}</span>
                <span className="text-[12px] font-mono text-[#6B7280]">{log.ip}</span>
                <span className={`text-[12px] font-semibold ${log.outColor}`}>{log.outcome}</span>
              </div>
            ))}
          </div>

        </div>
  );
}
